const featuresPriority = {
  'features-priority-form-date-label': 'Date',
  'features-priority-filter-title': 'Select features by date',
  'features-priority-title': 'Set specific order for featured content',
};

export default featuresPriority;
